module.exports = __webpack_public_path__ + "img/81.eff83afe.png";